import { render } from "./ProductCredits.vue?vue&type=template&id=1a492a82&scoped=true"
import script from "./ProductCredits.vue?vue&type=script&lang=js"
export * from "./ProductCredits.vue?vue&type=script&lang=js"

import "./ProductCredits.vue?vue&type=style&index=0&id=1a492a82&lang=less&scoped=true"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a492a82"]])

export default __exports__